<template>
  <div class="md:flex md:items-center md:space-x-4">
    <div class="flex-grow">
      <p class="text-2xl font-semibold leading-none font-display">
        {{ title }}
      </p>
      <p class="mt-1 text-sm text-gray-500">
        {{ desc }}
      </p>
    </div>
    <div class="mt-2 md:ms-auto">
      <VyButton
        size="lg"
        color="primary"
        shape="rounded"
        theme="solid"
        direction="rowReverse"
        :icon="buttonIcon"
        :label="buttonLabel"
        @click="$emit('click')"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    desc: {
      type: String,
      default: null,
    },
    buttonLabel: {
      type: String,
      default: null,
    },
    buttonIcon: {
      type: String,
      default: null,
    },
  },
  emits: ["click"],
};
</script>
